import { useState, useEffect, useMemo, useCallback } from "react";
import userServices from "services/userServices";
import { buildUnreadTargetsSet, normalizeTargetType } from "utils/notificationHelper";

export function useNotificationHighlight() {
  const [unreadNotifications, setUnreadNotifications] = useState([]);

  const fetchUnread = useCallback(async () => {
    try {
      const res = await userServices.fetchNotifications({ audience: "admin" });
      const raw = res?.data || res;
      const list = raw?.notifications || (Array.isArray(raw) ? raw : []);
      setUnreadNotifications(list.filter((n) => n.read === false));
    } catch (err) {
      // Ignore fetch errors
    }
  }, []);

  useEffect(() => {
    fetchUnread();

    const handleUpdate = () => {
      fetchUnread();
    };

    window.addEventListener("notificationsRead", handleUpdate);
    return () => {
      window.removeEventListener("notificationsRead", handleUpdate);
    };
  }, [fetchUnread]);

  const unreadSet = useMemo(() => {
    return buildUnreadTargetsSet(unreadNotifications);
  }, [unreadNotifications]);

  const isHighlighted = useMemo(() => {
    return (targetType, recordId) => {
      if (!recordId || !targetType || unreadSet.size === 0) return false;
      const normType = normalizeTargetType(targetType);
      const key = `${normType}:${recordId.toString()}`;
      return unreadSet.has(key);
    };
  }, [unreadSet]);

  return { isHighlighted, unreadSet };
}

export default useNotificationHighlight;
